import { createFileRoute, linkOptions } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import NotFoundResource from '@/components/router/not-found-resource'
import CoverageSheetContent from '@/components/sheets/coverage/coverage-sheet-content'
import { coverageSheetPreload } from '@/components/sheets/coverage/coverage-sheet-preload'
import { ViewTransitionType } from '@/css/view-transition.types'

export const Route = createFileRoute(
  '/app/data/groups/$uuid/$policyUuid/$coverageUuid/',
)({
  component: RouteComponent,
  loader: ({ params, context: { queryClient } }) =>
    coverageSheetPreload(params.coverageUuid, queryClient),
  errorComponent: (props) => {
    const { t } = useTranslation()

    return (
      <NotFoundResource
        {...props}
        resourceType={t('resource-not-found.not-found.coverage.resource-type')}
        backTo={t(
          'resource-not-found.not-found.coverage.back-to-coverages-list',
        )}
        backToLink={backLink}
      />
    )
  },
})

const backLink = linkOptions({
  from: Route.fullPath,
  to: '..',
  viewTransition: { types: [ViewTransitionType.SheetChildToParent] },
})

function RouteComponent() {
  const { coverageUuid } = Route.useParams()

  return (
    <CoverageSheetContent coverageUuid={coverageUuid} backLink={backLink} />
  )
}
